import React from "react";

import { useTranslation } from "react-i18next";
import useScreenOrientation from "../../hooks/useScreenOrientation";
import deviceHelper from "../../utils/helpers/deviceHelper";

import "./LandscapeNotification.css";

function LandscapeNotification() {
  const PORTRAIT_ORIENTATION_TYPE = "portrait";

  const isMobile = deviceHelper.isMobileDevice();
  const screenOrientation = useScreenOrientation();
  const { t } = useTranslation();

  const shouldRenderNotification =
    isMobile && screenOrientation === PORTRAIT_ORIENTATION_TYPE;

  if (!shouldRenderNotification) return null;

  return (
    <div className="landscape-notification">
      <p>
        {t("LANDSCAPE_VIEW")} <br />
        {t("ROTATE_PHONE")}
      </p>
      <div className="landscape-notification__icon">
        <img
          src="./design/new-exports/mobile-rotate-rotation-icon.svg"
          alt=""
        />
      </div>
    </div>
  );
}

export default LandscapeNotification;
